// PasswordResetModal
import React from 'react';
import MailCodeModal from './MailCodeModal';

const PasswordResetModal = ({
    visible,
    onClose,
    defaultEmail = '',
}) => {
    return (
        <MailCodeModal
            mode="passwordReset"
            visible={visible}
            onClose={onClose}
            defaultEmail={defaultEmail}
        />
    );
};

export default PasswordResetModal;